<template>
  <section class="mt-5">
    <h2>会員サイトご利用登録</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li class="here">入力</li>
        <li>確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <p>
        会員サイトご利用に必要な情報の登録をお願いします。下記項目をご入力の上、「確認画面へ進む」ボタンを押してください。
      </p>
      <div class="form-member my-5">
        <div class="inner">
          <dl>
            <dt>会員番号<span class="rqr">必須</span></dt>
            <dd>
              <input
                v-model="userID"
                ref="userID"
                type="text"
                maxlength="100"
                style="ime-mode: disabled"
              /><br />
              <p>
                ・ご使用頂いている会員番号を入力してください。
              </p>
            </dd>
            <dt>パスワード<span class="rqr">必須</span></dt>
            <dd>
              <input
                v-model="password"
                ref="password"
                type="password"
                style="ime-mode: disabled"
                autocomplete="off"
              /><br />
              <p>
                半角英字と数字を組み合わせて8桁以上12桁以下の入力をお願いします。
              </p>
            </dd>
            <dt>パスワード (再入力)<span class="rqr">必須</span></dt>
            <dd>
              <input
                v-model="rePassword"
                ref="rePassword"
                type="password"
                style="ime-mode: disabled"
                autocomplete="off"
              /><br />
              <p>
                確認のため、パスワードで入力した内容を再度入力してください。
              </p>
            </dd>
            <dt>
              PC・スマートフォン用メールアドレス<span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="mailAddress"
                ref="mailAddress"
                type="email"
                class=""
                style="ime-mode: disabled"
              /><br />
              <p>
                <!-- ・ここで入力したメールアドレスが、会員サイトのログインIDになります。<br /> -->
                ・ご使用のメールアプリの設定によっては弊社からのメールが受信頂けない場合があります。迷惑メール設定のご確認、およびドメイン指定受信をご設定の方は「manavis-cosme.co.jp」からのメール受信の許可をお願いします。
              </p>
            </dd>
            <dt>電話番号下四桁<span class="rqr">必須</span></dt>
            <dd>
              <input
                v-model="telUnder"
                ref="telUnder"
                type="text"
                maxlength="4"
                style="ime-mode: disabled"
              /><br />
              <p>
                ・マナビス化粧品入会者であることを認証させるために使用します。それ以外の目的で使用しません
              </p>
            </dd>
          </dl>
          <p class="my-5">
            以下の項目では各種セミナー・キャンペーン等のお知らせのほか、会員ご本人様の実績（自己購入数量・グループ人数・グループ数量）をご登録頂いたメールに配信いたします。ぜひこの機会に「メール配信サービス」をご登録下さい。<br />
            ※会員サイトご利用後も登録、変更可能です。
          </p>
          <dl>
            <dt>実績メールの配信</dt>
            <dd>
              <input
                v-model="chkInterval"
                type="checkbox"
                id="chkInterval"
                class="check-01"
              />
              <label for="chkInterval">希望しない</label>
            </dd>
            <dt>お知らせメールの配信</dt>
            <dd>
              <input
                v-model="chkInfo"
                type="checkbox"
                id="chkInfo"
                class="check-01"
              />
              <label for="chkInfo">希望しない</label><br />
              <p>
                メール配信サービスにご登録の方には、キャンペーン情報やセミナー開催情報など、弊社からのお知らせを不定期に配信します。弊社からのお知らせが不要な方は、上記の「希望しない」にチェックをつけてください。
              </p>
            </dd>
          </dl>
          <div class="box-p-20 text-center mt-5">
            <button v-on:click="putData" type="submit" id="Confirm">
              確認画面へ進む
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Message from "@/modules/Message";
import Utl from "@/modules/Utl";
import Request from "@/modules/Request";
let request = new Request();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
import Store from "@/modules/Store";
let store = new Store();
export default {
  data() {
    return {
      mailAddress: "",
      password: "",
      rePassword: "",
      userID: "",
      telUnder: "",
      chkInterval: false,
      chkInfo: false,
      monthList: [],
      dayList: [],
      dicRefs: [],
    };
  },
  mounted() {
    this.getData();
    this.dicRefs = {
      arg1: this.$refs.userID,
      arg2: this.$refs.password,
      arg3: this.$refs.telUnder,
      arg4: this.$refs.mailAddress,
    };
    window.scroll(0, 0);
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSession",
        [],
        true,
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (auth.getNoLoginUid() == "") {
            this.uux = data.uux;
            auth.setNoLoginUid(this.uux);
          }
        });
      let str = store.get(auth.getNoLoginUid());
      if (str != "") {
        let obj = JSON.parse(str);
        this.mailAddress = obj.mailAddress;
        this.password = obj.password;
        this.rePassword = obj.rePassword;
        this.userID = obj.userID;
        this.telUnder = obj.telUnder;
        this.chkInterval = obj.chkInterval;
        this.chkInfo = obj.chkInfo;
      }
    },
    putData() {
      if (!this.chkMailAddress()) return;
      if (!this.chkPassword()) return;
      if (!this.chkRePassword()) return;
      if (!this.chkUserID()) return;
      if (!this.chkTelUnder()) return;
      let dataList = {
        mailAddress: this.mailAddress,
        password: this.password,
        rePassword: this.rePassword,
        userID: this.userID,
        telUnder: this.telUnder,
        chkInterval: this.chkInterval,
        chkInfo: this.chkInfo,
      };
      let json = JSON.stringify(dataList, undefined, 1);
      store.set(auth.getNoLoginUid(), json);
      let requestParams = request.createParams("webMdlLogin", "tempLoginByTelNo", [
        this.userID,
        this.password,
        this.telUnder,
        this.mailAddress,
      ]);
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          let focusEl = null;
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                focusEl = this.dicRefs[data.arg];
                if (focusEl) {
                  focusEl.focus();
                }
              },
            });
          } else {
            this.$router.push("/register/confirm");
          }
        });
    },
    chkMailAddress() {
      let mes = Utl.chkMustInput("メールアドレス", this.mailAddress);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.mailAddress.focus();
          },
        });
        return false;
      }
      mes = Utl.chkMailAddress(
        "PC・スマートフォン用メールアドレス",
        this.mailAddress
      );
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.mailAddress.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkTelUnder(){
      let mes = Utl.chkMustInput("電話番号下四桁", this.telUnder);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.telUnder.focus();
          },
        });
        return false;
      }
      if (this.telUnder.length != 4) {
        Message.error().fire({
          title: "電話番号下四桁に誤りがあります。",
          didClose: () => {
            this.$refs.telUnder.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkPassword() {
      let mes = Utl.chkMustInput("パスワード", this.password);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.password.focus();
          },
        });
        return false;
      }
      mes = Utl.chkPassword("パスワード", this.password);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.password.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkRePassword() {
      let mes = Utl.chkMustInput("確認パスワード", this.rePassword);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.rePassword.focus();
          },
        });
        return false;
      }
      if (this.password != this.rePassword) {
        Message.error().fire({
          title: "確認パスワードに誤りがあります。",
          didClose: () => {
            this.$refs.rePassword.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkUserID() {
      let mes = Utl.chkMustInput("会員番号", this.userID);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.userID.focus();
          },
        });
        return false;
      }
      mes = Utl.chkUserID("会員番号", this.userID);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.userID.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>
